import React, { useEffect, useCallback } from "react";
import "./KeyboardShotcuts.scss";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { Box } from "@mui/system";
import { Modal } from "@mui/material";

interface Props {
  openStatus: boolean;
  attrName: string;
  valueUpdate: Function;
}

const KeyboardShotcuts: React.FC<Props> = ({
  openStatus,
  attrName,
  valueUpdate,
}) => {
  var shortcut_data = [
    {
      title: "Go to Home",
      value: "D",
    },
    {
      title: "Policies",
      value: "P",
    },
    {
      title: "Quotes",
      value: "Q",
    },
    {
      title: "Policy Renewal",
      value: "R",
    },
    {
      title: "Clients",
      value: "C",
    },
    {
      title: "Contacts",
      value: "N",
    },
    {
      title: "Employees",
      value: "E",
    },
    {
      title: "Product Configurator",
      value: "F",
    },
    {
      title: "Endorsement",
      value: "T",
    },
    {
      title: "Claim",
      value: "L",
    },
    {
      title: "Trending Questions",
      value: "G",
    },
    {
      title: "Community",
      value: "M",
    },
    {
      title: "Report",
      value: "E",
    },
    {
      title: "Support",
      value: "O",
    },
    {
      title: "Setting",
      value: "I",
    },
    {
      title: "Add new Quote",
      value: "Shift + Q",
    },
    {
      title: "Add new Policy",
      value: "Shift + P",
    },
    {
      title: "Add new Client",
      value: "Shift + C",
    },
    {
      title: "Add new Contact",
      value: "Shift + N",
    },
    {
      title: "Add new Employee",
      value: "Shift + E",
    },
    {
      title: "Post a Query",
      value: "Shift + G",
    },
    {
      title: "Post a Question",
      value: "Shift + M",
    },
    {
      title: "Add Quote",
      value: "Shift + Q",
    },
    {
      title: "Endorsement Request",
      value: "Shift + T",
    },
    {
      title: "New Claim Request",
      value: "Shift + L",
    },
  ];

  return (
    <Modal
      open={openStatus}
      onClose={() => {
        valueUpdate(attrName, false);
      }}
      className="keyboardWrapper">
      <Box className="keyboardShortcuts">
        <Grid container spacing={3}>
          <Grid xs={6}>
            <h4>Keyboard Shortcuts</h4>
          </Grid>
          <Grid xs={6}></Grid>
        </Grid>
        <Grid container spacing={0} className="shortcutKeys">
          {shortcut_data.map((data, index) => (
            <Grid xs={4}>
              <p>
                {data.title} <kbd>{data.value}</kbd>
              </p>
            </Grid>
          ))}
          {/* <Grid xs={6}>
                <p>Policies <kbd>P</kbd></p>
                <p>Transactions <kbd>T</kbd></p>
                <p>Renewals <kbd>R</kbd></p>
                <p>Customers <kbd>C</kbd></p>
            </Grid>
            <Grid xs={6}>
                <p>Search <kbd>ctrl Space</kbd></p>
                <p>Referesh <kbd>alt Space</kbd></p>
                <p>Add New Policy <kbd>alt N</kbd></p>
                <p>Car Dahboard <kbd>C</kbd></p>
                <p>Bike Dahboard <kbd>B</kbd></p>
                <p>Health Dahboard <kbd>H</kbd></p>
            </Grid> */}
        </Grid>
      </Box>
    </Modal>
  );
};

export default KeyboardShotcuts;
